import React from "react";
//importar la libreria moment.js
import moment from "moment";
//importar la hora local en español
import "moment/locale/es";
//importar efecto de la cabecera
import Flip from "react-reveal/Fade";
//importar el css module
import styles from "./Header.module.css";
//importar los filtros (ActiveFilters)
import ActiveFilters from "../ActiveFilters/ActiveFilters";
//En caso de que la libreria de la hora local no se importe correctamente
moment.locale("es");

function Header(props) {
  const {
    from,
    to,
    filterCountry,
    filterPrice,
    filterSize,
    filtersActives,
    checkPrice,
    priceMsg,
    defaultValues
  } = props;

  return (
    <header className={styles.header}>
      <Flip left>
        <h1 className={styles.header__title}>
          reserva de hoteles <br />
          {/* <span className = { styles.header__title__span}>
      En cualquier fecha  <br />
      De cualquier precio <br />
      De cualquier tamaño <br />
      </span> */}
        </h1>
      </Flip>

      <ActiveFilters
        prices={filterPrice}
        size={filterSize}
        country={filterCountry}
        checkIn={from}
        checkOut={to}
        filtersActives={filtersActives}
        checkPrice={checkPrice}
        headerPriceMsg={priceMsg}
        defaultValues={defaultValues}
      />
    </header>
  );
}

export default Header;
